/* src/app/home/custom-name-modal/custom-name-modal.component.scss */
.custom-name-modal {
  min-width: 100%;
  position: relative;
}
.custom-name-modal .modal-header {
  border: none;
  padding: 22px 0 0;
  height: 60px;
}
.custom-name-modal .modal-header .modal-title {
  font-size: 32px;
  padding: 0 60px;
  line-height: normal;
}
.custom-name-modal .modal-body {
  border: none;
  padding: 17px 60px 32px;
}
.custom-name-modal .modal-body label {
  font-weight: bold !important;
  margin-bottom: 0;
}
.custom-name-modal .modal-body .custom-name-warning {
  font-style: italic;
  padding-bottom: 16px;
}
.custom-name-modal .modal-body .info-text {
  padding-bottom: 16px;
}
.custom-name-modal .modal-body div div:nth-last-of-type(2) {
  padding-bottom: 25px;
}
.custom-name-modal .modal-footer {
  border: none;
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 100%;
  padding: 0 0 32px;
}
.custom-name-modal .close-icon {
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 16px;
  padding-left: 10px;
  color: #404040;
}
.btn-green {
  color: white;
  font-size: 13px;
  background-color: #00857D;
  border-radius: 35px;
  width: 118px;
  height: 36px;
  margin: 0;
}
.btn-green:disabled {
  color: #757575;
}
.input-label {
  padding-bottom: 5px;
}
.error-message {
  margin-top: 0.5rem;
  color: #C91913;
}
/*# sourceMappingURL=custom-name-modal.component.css.map */
